import './plugin/load'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider } from './hooks/use-auth'
import { FocusStoreProvider } from './hooks/use-focus-store'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <FocusStoreProvider>
        <App />
      </FocusStoreProvider>
      <Toaster richColors closeButton />
    </AuthProvider>
  </QueryClientProvider>
)
